import { UserRole } from '../../../shared/enums';

const PermissionsOfInterviews = {
  MakeAudioFilesRequired: [UserRole.ADMIN, UserRole.EDITOR],
  UploadAudioFiles: [UserRole.ADMIN, UserRole.EDITOR, UserRole.WRITER],
  DeleteAudioFiles: [UserRole.ADMIN, UserRole.EDITOR, UserRole.WRITER],
  DownloadAudioFiles: [UserRole.ADMIN, UserRole.EDITOR, UserRole.WRITER],
  UploadTranscriptFiles: [UserRole.ADMIN, UserRole.EDITOR],
  DeleteTranscriptFiles: [UserRole.ADMIN, UserRole.EDITOR],
  DownloadTranscriptFiles: [UserRole.ADMIN, UserRole.EDITOR, UserRole.WRITER],
  CompleteInterviewStage: [UserRole.ADMIN, UserRole.EDITOR, UserRole.WRITER],
  TranscribeFile: [UserRole.ADMIN, UserRole.EDITOR, UserRole.WRITER],
};

export default PermissionsOfInterviews;
